import type { ComponentProps } from "react";
import { PanelShell } from "../PanelShell";

export const TableShell = ({
  className,
  ...props
}: ComponentProps<typeof PanelShell>) => (
  <PanelShell
    {...props}
    className={`focusoc-table-shell h-full flex-1 ${className ?? ""}`}
  />
);
